<template>
  <div class="witness-container" v-loading="loading">
    <!-- 顶部标题与按钮 -->
    <div class="witness-header">
      <div class="section-title">证人管理</div>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增证人</el-button>
    </div>

    <!-- 说明文字 -->
    <div class="witness-desc">
      录入证人信息后，向上传相关证明文件，再以短信方式发送"证明通知"。证人点击短信链接跳转到微信小程序，查看案件调查文件（只读），在线手写签名。签名信息及签名时间将作为水印体现在签字证实文件中，社保用户可在此查看。
    </div>

    <!-- 空状态 -->
    <div v-if="witnessList.length === 0" class="witness-empty">
      暂无证人信息，请点击"新增证人"录入
    </div>

    <!-- 证人卡片列表 -->
    <div v-else class="witness-list">
      <div v-for="item in witnessList" :key="item.id" class="witness-card">
        <!-- 头部：姓名 + 操作 -->
        <div class="card-head">
          <div class="name">{{ item.witnessName }}</div>
          <el-button
            type="text"
            icon="el-icon-delete"
            class="head-delete-btn"
            @click="handleDeleteWitness(item)"
          >删除</el-button>
        </div>

        <!-- 基本信息 -->
        <div class="card-info">
          <div class="info-item">
            <span class="label">手机：</span>
            <span class="value">{{ item.witnessPhone }}</span>
          </div>
          <div class="info-item">
            <span class="label">身份证：</span>
            <span class="value">{{ item.witnessIdNumber }}</span>
          </div>

        </div>

        <!-- 证明文件区域 -->
        <div class="" v-for="i in item.signatureList" :key="i.id">
          <div class="card-files">
          <div class="files-title">
            <div class="files-title-left">
              <i class="el-icon-paperclip"></i>
              <span>证明文件</span>
              <span v-if="i.send === 2 && i.sendTime" class="send-time">发送时间：{{ formatDate(i.sendTime) }}</span>
            </div>
            <el-tag :type="i.send === 2 ? 'success' : 'info'" size="small">
              {{ i.send === 2 ? '已发送' : '待发送' }}
            </el-tag>
          </div>

          <!-- 无文件 -->
          <div v-if="!i.sysFileDto" class="files-empty">
            <div class="empty-text">暂无证明文件</div>
            <div class="empty-tip">
              请先上传证明材料，上传完附件后再发送证明通知。
            </div>
          </div>
          <!-- 有文件 -->
          <ul v-else class="files-list">
            <li class="file-item">
              <i class="el-icon-document file-icon"></i>
              <span class="file-name">{{ i.sysFileDto.originName }}</span>
              <span class="file-size">{{ formatSize(i.sysFileDto.size) }}</span>
              <span class="file-date">{{ formatDate(i.sysFileDto.createTime) }}</span>
              <span class="file-actions">
                <el-button type="text" size="mini" @click="handlePreview(item, i.sysFileDto)">预览</el-button>
                <el-button type="text" size="mini" @click="handleDownload(item, i.sysFileDto)">下载</el-button>
<!--                <el-button type="text" size="mini" style="color:#f56c6c;" @click="handleDeleteFile(item, file)">删除</el-button>-->
              </span>
            </li>
            <!--  签署信息-->
            <div v-if="i.status==2">
              <li class="file-item">
                <i class="el-icon-document file-icon"></i>
                <span class="file-name">{{ i.signatureFileDto.originName }}</span>
                <span class="file-size">{{ formatSize(i.signatureFileDto.size) }}</span>
                <span class="file-date">{{ formatDate(i.signatureTime) }}</span>
                <span class="file-actions">
                <el-button type="text" size="mini" @click="handlePreview(item, i.signatureFileDto)">预览</el-button>
                <el-button type="text" size="mini" @click="handleDownload(item, i.signatureFileDto)">下载</el-button>
              </span>
              </li>
            </div>
          </ul>
          </div>
          <!-- 操作按钮区 -->
          <div class="card-actions">
            <el-button
                :disabled="!i.sysFileDto || i.send === 2"
                @click="handleSendNotice(item,i)"
            >
              发送证明通知
            </el-button>
            <el-upload
                class="upload-btn"
                :action="uploadAction"
                :show-file-list="false"
                :http-request="(opt) => handleUpload(opt, item,i)"
                :before-upload="beforeUpload"
                accept=".pdf"
                :disabled="i.uploadLoading"
            >
              <el-button :disabled="i.send === 2" :loading="i.uploadLoading">{{ i.sysFileDto ? '重新上传证明材料' : '上传证明材料' }}</el-button>
            </el-upload>
            <el-button type="danger"  :disabled="!i.sysFileDto || i.send === 2" plain @click="handleDeleteProof(i)">删除</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增证人弹窗 -->
    <myDialog
      :isDialog="addDialogVisible"
      title="新增证人"
      width="540px"
      :isFooter="true"
      @handleClose="addDialogVisible = false"
    >
      <template slot="content">
        <el-form
          ref="addFormRef"
          :model="addForm"
          :rules="addFormRules"
          label-width="100px"
          class="witness-form"
        >
          <el-form-item label="姓名" prop="witnessName">
            <el-input v-model="addForm.witnessName" placeholder="请输入证人姓名" maxlength="50" />
          </el-form-item>
          <el-form-item label="手机号码" prop="witnessPhone">
            <el-input v-model="addForm.witnessPhone" placeholder="11位手机号" maxlength="11" />
          </el-form-item>
          <el-form-item label="身份证号码" prop="witnessIdNumber">
            <el-input v-model="addForm.witnessIdNumber" placeholder="18位身份证号码" maxlength="18" />
          </el-form-item>
          <!-- <el-form-item label="证明通知" prop="notice">
            <el-input
              type="textarea"
              v-model="addForm.notice"
              :rows="6"
              placeholder="请输入证明通知内容"
            /> -->
          </el-form-item>
        </el-form>
      </template>
      <template slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="handleSubmitAdd">保存</el-button>
      </template>
    </myDialog>
  </div>
</template>

<script>
import myDialog from '@/components/myComponents/myDialog/index.vue'
import { uploadFile } from '@/api/upload/upload'
import {
  getWitnessList,
  addWitness,
  deleteWitness,
  sendNotice,
  addWitnessFile, updateWitnessFile,
  deleteWitnessSignature
} from '@/api/recognition/witness'

export default {
  name: 'WitnessManagement',
  components: { myDialog },
  props: {
    step1info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的11位手机号'))
      } else {
        callback()
      }
    }
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号码'))
      } else if (!/^\d{17}[\dXx]$/.test(value)) {
        callback(new Error('请输入正确的18位身份证号码'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      witnessList: [],
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        witnessName: '',
        witnessPhone: '',
        witnessIdNumber: '',
        notice: ''
      },
      addFormRules: {
        witnessName: [{ required: true, message: '请输入证人姓名', trigger: 'blur' }],
        witnessPhone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        witnessIdNumber: [{ required: true, validator: validateIdCard, trigger: 'blur' }],
        // notice: [{ required: true, message: '请输入证明通知', trigger: 'blur' }]
      },
      uploadAction: '#'
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      const caseId = this.$route.query.id
      if (!caseId) return
      this.loading = true
      getWitnessList({ caseId })
        .then(res => {
          if (res && res.code === 200) {
            this.witnessList = (res.data || []).map(item => ({
              ...item,
              files: item?.signatureList?.map(file => {
                    return {
                      ...file.sysFileDto
                    }
                  }
              ),
              signatureList: item?.signatureList?.length<1 ? [{}] : item?.signatureList || []
            }))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    // 生成证明通知默认文本
    buildDefaultNotice() {
      const company = this.step1info?.unitName || ''
      const injuredName = this.step1info?.woundedName || ''
      return `【宝山人社】您好！在${company}${injuredName}的工伤认定调查中，当事人提交了一份署名为您的书面证言。为核实证言真实性，请您在3个工作日内，通过微信搜索"宝就业"小程序，进入"劳动保障"板块下的"工伤认定"模块，核对证言内容，确认是否为本人真实意见，您可选择确认属实、内容不符、非本人出具。如有疑问，请拨打咨询电话021-56107019。若您与该事确无任何关联，可忽略本消息。感谢配合！`
    },

    handleAdd() {
      this.addForm = {
        witnessName: '',
        witnessPhone: '',
        witnessIdNumber: '',
        // notice: this.buildDefaultNotice()
      }
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate()
      })
    },

    handleSubmitAdd() {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        const caseId = this.$route.query.id
        if (!caseId) {
          this.$message.error('案件ID不存在')
          return
        }
        this.addLoading = true
        addWitness({
          caseId,
          witnessName: this.addForm.witnessName,
          witnessPhone: this.addForm.witnessPhone,
          witnessIdNumber: this.addForm.witnessIdNumber
        })
          .then(res => {
            if (res && res.code === 200) {
              this.$message.success('证人信息保存成功')
              this.addDialogVisible = false
              this.fetchList()
            } else {
              this.$message.error(res?.msg || '保存失败')
            }
          })
          .catch(() => {
            this.$message.error('保存失败')
          })
          .finally(() => {
            this.addLoading = false
          })
      })
    },

    handleDeleteWitness(item) {
      this.$confirm(`确认删除证人"${item.witnessName}"吗？相关证明文件也将一并删除。`, '提示', {
        type: 'warning'
      }).then(() => {
        deleteWitness({ id: item.id }).then(res => {
          if (res && res.code === 200) {
            this.$message.success('删除成功')
            this.fetchList()
          } else {
            this.$message.error(res?.msg || '删除失败')
          }
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },
    handleDeleteProof(i){
      this.$confirm(`确认删除该证明吗?`, '提示', {
        type: 'warning'
      }).then(() => {
        deleteWitnessSignature({ id: i.id }).then(res => {
          if (res && res.code === 200) {
            this.$message.success('删除成功')
            this.fetchList()
          } else {
            this.$message.error(res?.msg || '删除失败')
          }
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },

    handleSendNotice(item, i) {
      this.$confirm(`确认向证人"${item.witnessName}"发送证明通知吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        sendNotice({ id: i.id }).then(res => {
          if (res && res.code === 200) {
            this.$message.success(`证明通知短信已发送至${item.witnessPhone}，证人可点击短信链接进入微信小程序`)
            this.fetchList()
          } else {
            this.$message.error(res?.msg || '发送失败')
          }
        }).catch(() => {
          this.$message.error('发送失败')
        })
      }).catch(() => {})
    },

    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB')
        return false
      }
      return true
    },

    handleUpload(option, item, i) {
      const file = option.file
      this.$set(i, 'uploadLoading', true)
      const formdata = new FormData()
      formdata.append('file', file)
      formdata.append('type', 'witness')
      formdata.append('witnessId', item.id)
      formdata.append('caseId', this.$route.query.id || '')
      uploadFile(formdata).then(async res => {
        if (res && res.code === 200 && res.data) {
          if (!item.files) {
            this.$set(item, 'files', [])
          }
          const newFile = {
            id: res.data.id || Date.now(),
            name: res.data.originName || file.name,
            url: res.data.url || res.data.filePath,
            size: file.size,
            createTime: new Date()
          }
          // // 只保留一个文件，重新上传时替换
          // if (item.files.length > 0) {
          //   this.$set(item.files, 0, newFile)
          // } else {
          //   item.files.push(newFile)
          // }
          if (i.id) {
           await updateWitnessFile({id:i.id,witnessId:item.id,pendingSignatureFileUrl:newFile.url,pendingSignatureFileId:newFile.id})
          } else {
            await addWitnessFile({witnessId:item.id,pendingSignatureFileUrl:newFile.url,pendingSignatureFileId:newFile.id})
          }
          this.fetchList()
          this.$message.success('上传成功')
        } else {
          this.$message.error(res?.msg || '上传失败')
        }
      }).catch(() => {
        this.$message.error('上传失败')
      }).finally(() => {
        this.$set(i, 'uploadLoading', false)
      })
    },

    handleDeleteFile(item, file) {
      this.$confirm(`确认删除文件"${file.name}"吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        const idx = item.files.findIndex(f => f.id === file.id)
        if (idx > -1) item.files.splice(idx, 1)
        this.$message.success('删除成功')
      }).catch(() => {})
    },

    handlePreview(item, file) {
      if (!file.url) {
        this.$message.warning('暂不支持预览此文件')
        return
      }
      window.open(this.resolvePreviewUrl(file.url), '_blank')
    },

    handleDownload(item, file) {
      if (!file.url) {
        this.$message.warning('暂不支持下载此文件')
        return
      }
      const url = this.resolvePreviewUrl(file.url)
      window.open(url, '_blank')
    },

    resolvePreviewUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')) return url
      return (this.imageUrlprefix || process.env.VUE_APP_IMAGEURLPREFIX || '') + url
    },

    formatSize(size) {
      if (!size && size !== 0) return ''
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
      return (size / 1024 / 1024).toFixed(2) + ' MB'
    },

    formatDate(val) {
      if (!val) return ''
      return val
    }
  }
}
</script>

<style lang="scss" scoped>
.witness-container {
  width: 100%;
  padding: 16px 0;
}

.witness-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.section-title {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  padding-left: 11px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 12px;
    border-radius: 20px;
    background: var(--vt-c-blue, #409eff);
  }
}

.witness-desc {
  font-size: 13px;
  color: #909399;
  line-height: 1.8;
  padding: 8px 0 16px;
}

.witness-empty {
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

.witness-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.witness-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px 20px;

  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .name {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }

    .head-delete-btn {
      color: #f56c6c;
      padding: 4px 8px;
    }

    .status {
      flex-shrink: 0;
    }
  }

  .card-info {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    font-size: 13px;
    color: #606266;
    margin-bottom: 14px;

    .info-item {
      display: flex;
      align-items: center;

      .label {
        color: #909399;
        margin-right: 4px;
      }

      .value {
        color: #303133;
      }
    }
  }

  .card-files {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px 14px;
    margin-bottom: 14px;

    .files-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      color: #606266;
      font-weight: 500;
      margin-bottom: 10px;

      .files-title-left {
        display: flex;
        align-items: center;
        gap: 6px;

        .send-time {
          color: #909399;
          font-size: 12px;
          margin-left: 12px;
        }
      }

      i {
        color: #909399;
      }
    }

    .files-empty {
      .empty-text {
        font-size: 13px;
        color: #909399;
        margin-bottom: 8px;
      }

      .empty-tip {
        background: #fdf6ec;
        color: #b88230;
        border-radius: 4px;
        padding: 8px 12px;
        font-size: 12px;
      }
    }

    .files-list {
      list-style: none;
      margin: 0;
      padding: 0;

      .file-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 0;
        border-bottom: 1px dashed #ebeef5;
        font-size: 13px;

        &:last-child {
          border-bottom: none;
        }

        .file-icon {
          color: #409eff;
          font-size: 16px;
        }

        .file-name {
          flex-shrink: 0;
          max-width: 200px;
          color: #303133;
        }

        .file-size {
          color: #909399;
          min-width: 80px;
        }

        .file-date {
          color: #909399;
          min-width: 160px;
        }

        .file-actions {
          margin-left: auto;
          flex-shrink: 0;

          .el-button + .el-button {
            margin-left: 4px;
          }
        }
      }
    }
  }

  .card-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .upload-btn {
      display: inline-block;
    }

    /deep/ .el-upload {
      display: inline-block;
    }
  }
}

.witness-form {
  padding: 10px 20px 0 0;

  /deep/ .el-form-item__label {
    color: #606266;
  }
}
</style>